h5 = h5 || {};

h5['dashboard-lite'] = {
   angularModule: angular.module('com.vmware.vsphere.client.dashboard-lite', [])
};
